// @flow
import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';
import { itemClicked } from '../../../app/browser/analyticsHelpers';

const activityLocation = 'SP : Service Area';

const otherProps = {
  serviceProviderId: '[[serviceAreas.serviceProviderServiceAreas.request.serviceProviderId]]',
};

export default {
  page: {
    name: activityLocation,
    properties: {
      ...defaultPageProps,
      ...otherProps,
    },
  },
  elements: {
    'service-areas--save-button': (itemClicked(activityLocation, 'Store Page - AboutTab - Save Service Area', otherProps): any),
    'service-areas-modal--confirm-button': (itemClicked(activityLocation, 'Store Page - AboutTab - Confirm Service Area', otherProps): any),
  },
};



// WEBPACK FOOTER //
// ./src/modules/store/browser/serviceAreaViewAnalytics.js